"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const CheckCircle_1 = __importDefault(require("@mui/icons-material/CheckCircle"));
const Error_1 = __importDefault(require("@mui/icons-material/Error"));
const Warning_1 = __importDefault(require("@mui/icons-material/Warning"));
const material_1 = require("@mui/material");
const clsx_1 = require("clsx");
require("./alert.scss");
const Alert = (_a) => {
    var { className, severity = 'error', title, children } = _a, otherProps = __rest(_a, ["className", "severity", "title", "children"]);
    const alertClassName = 'RSPAlert';
    const combinedClassName = (0, clsx_1.clsx)(className, alertClassName);
    let muiSeverity;
    let icon;
    switch (severity) {
        default:
        case 'error':
            muiSeverity = 'error';
            icon = (0, jsx_runtime_1.jsx)(Error_1.default, {});
            break;
        case 'warning':
            muiSeverity = 'warning';
            icon = (0, jsx_runtime_1.jsx)(Warning_1.default, {});
            break;
        case 'success':
            muiSeverity = 'success';
            icon = (0, jsx_runtime_1.jsx)(CheckCircle_1.default, {});
            break;
    }
    return ((0, jsx_runtime_1.jsxs)(material_1.Alert, Object.assign({}, otherProps, { className: combinedClassName, icon: icon, severity: muiSeverity, variant: "outlined", children: [title && (0, jsx_runtime_1.jsx)(material_1.AlertTitle, { children: title }), title && children && (0, jsx_runtime_1.jsx)("div", { className: `${alertClassName}-space` }), children && (0, jsx_runtime_1.jsx)("div", { className: `${alertClassName}-description`, children: children })] })));
};
exports.Alert = Alert;
//# sourceMappingURL=alert.js.map